export default "__VITE_ASSET__D9m76u0e__"